import { Component, Renderer } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { SettingsPage } from '../settings/settings';
import { SettingService } from '../../services/setting-service';
import { App } from 'ionic-angular/components/app/app';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-ivr-modal',
  templateUrl: 'ivr-modal.html',
})
export class IvrModalPage {
  message = "";
  title = "";
  dontshow = false;
  constructor(
    private storage: Storage, 
    private SettingService:SettingService,
    private app: App,
    private translate: TranslateService,
    public navCtrl: NavController,
    public navParams: NavParams,
    private viewCtrl: ViewController,
    private renderer: Renderer) {
      this.message = navParams.get('message');
      this.title = navParams.get('title');
      this.renderer.setElementClass(viewCtrl.pageRef().nativeElement, 'popup', true); 
  }

  onGoto(){
      this.app.getRootNav().push(SettingsPage);
      this.dismiss();
    }

  setPopupDontShow(){
    console.log(this.dontshow);
    let  setting ={
      ivr_not_set_popup : this.dontshow
    }
    this.SettingService.setAppSettings(setting);
  }
  
  dismiss() {
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad IvrModalPage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/ivr-modal/ivr-modal.ts